import React, { Component } from 'react'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import Button from '@mui/material/Button'
import Alert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import CircularProgress from '@mui/material/CircularProgress'
import ReportProblem from '@mui/icons-material/ReportProblem'

const RestTunel = require('../../libs/rest_tunnel')

// Listas fijas (espejo de back/libs/soporte-constants.js)
const CATEGORIAS = [
  'Billetero/aceptación de billetes', 'Depósito y transacción', 'Bóveda y cerradura',
  'Bolsa/cashbox', 'Comunicación y conectividad', 'Impresora', 'Equipo fuera de servicio',
  'Usuarios, funcionarios y depositantes', 'Apertura de bóveda/transportadora',
  'Reportes y datos', 'Mantenimiento correctivo', 'Consultas y solicitudes administrativas'
]
const MODULOS = [
  'Inicio de sesión', 'Reportes', 'Transacciones', 'Monitoreo', 'Administración de cajeros',
  'Funcionarios', 'Depositantes', 'Billetera', 'Mi cuenta', 'Otro'
]
const SEVERIDADES = [
  { nivel: 1, definicion: 'El equipo no puede hacer operaciones de dinero.' },
  { nivel: 2, definicion: 'El equipo funciona pero presenta fallas en las operaciones.' },
  { nivel: 3, definicion: 'El equipo opera; impacto menor, dudas o alarmas no críticas.' }
]

class SoporteReportarPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tipo: 'maquina',
      cajeros: [], entidades: [],
      cajero_id: '', entidad_id: '', categoria: '', modulo: '',
      severidad: '', descripcion: '', fecha_problema: '', info_adicional: '',
      archivo: null,
      cargando: false, enviando: false,
      snack: { open: false, severity: 'success', msg: '' }
    }
  }

  componentDidMount() { this.cargarCajeros() }

  cargarCajeros = () => {
    this.setState({ cargando: true })
    RestTunel.makePetition({
      method: 'POST', headers: 'JSON', body: {},
      url: process.env.REACT_APP_URL_BACKEND + '/soporte/cajeros'
    }, (err, data) => {
      if (err) { this.setState({ cargando: false }); return this.avisar('error', (data && data.message) || 'No se pudieron cargar los cajeros') }
      const entidades = data.entidades || []
      this.setState({
        cajeros: data.cajeros || [], entidades: entidades,
        entidad_id: entidades.length === 1 ? entidades[0].id : '',
        cargando: false
      })
    })
  }

  avisar = (severity, msg) => this.setState({ snack: { open: true, severity, msg } })
  set = (campo) => (e) => this.setState({ [campo]: e.target.value })

  enviar = () => {
    const s = this.state
    if (!s.descripcion || s.descripcion.trim().length < 3) return this.avisar('warning', 'Describe el problema')
    if (!s.severidad) return this.avisar('warning', 'Selecciona la severidad')

    const fd = new FormData()
    fd.append('tipo', s.tipo)
    fd.append('severidad', s.severidad)
    fd.append('descripcion', s.descripcion)
    if (s.fecha_problema) fd.append('fecha_problema', s.fecha_problema.replace('T', ' ') + ':00')
    if (s.info_adicional) fd.append('info_adicional', s.info_adicional)

    if (s.tipo === 'maquina') {
      if (!s.cajero_id) return this.avisar('warning', 'Selecciona el cajero')
      if (!s.categoria) return this.avisar('warning', 'Selecciona la categoría')
      fd.append('cajero_id', s.cajero_id)
      fd.append('categoria', s.categoria)
    } else {
      if (!s.entidad_id) return this.avisar('warning', 'Selecciona la entidad')
      if (!s.modulo) return this.avisar('warning', 'Selecciona el módulo')
      fd.append('entidad_id', s.entidad_id)
      fd.append('modulo', s.modulo)
    }
    if (s.archivo) fd.append('adjunto', s.archivo)

    this.setState({ enviando: true })
    RestTunel.makePetition({
      method: 'POST', body: fd,
      url: process.env.REACT_APP_URL_BACKEND + '/soporte/crear'
    }, (err, data) => {
      this.setState({ enviando: false })
      if (err) return this.avisar('error', (data && data.message) || 'No se pudo crear la solicitud')
      this.avisar('success', 'Solicitud ' + (data && data.sup ? data.sup : '') + ' creada')
      setTimeout(() => this.props.history.push('/dashboard/soporte'), 900)
    })
  }

  render() {
    const s = this.state
    return (
      <Box sx={{ p: 2 }}>
        <Paper sx={{ p: 3, maxWidth: 860, mx: 'auto' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <ReportProblem sx={{ color: 'warning.main', mr: 1 }} />
            <Typography variant="h5">Reportar una falla</Typography>
          </Box>

          {s.cargando ? <CircularProgress /> :
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="subtitle2" color="text.secondary">¿Qué falla?</Typography>
              <RadioGroup row value={s.tipo} onChange={this.set('tipo')}>
                <FormControlLabel value="maquina" control={<Radio />} label="Una máquina (cajero)" />
                <FormControlLabel value="plataforma" control={<Radio />} label="Smart Safe Control (plataforma)" />
              </RadioGroup>
            </Grid>

            {s.tipo === 'maquina' ? <>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Cajero</InputLabel>
                  <Select label="Cajero" value={s.cajero_id} onChange={this.set('cajero_id')}>
                    {s.cajeros.map(c => <MenuItem key={c.id} value={c.id}>{c.codigo}{c.alias ? ' — ' + c.alias : ''}</MenuItem>)}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Categoría</InputLabel>
                  <Select label="Categoría" value={s.categoria} onChange={this.set('categoria')}>
                    {CATEGORIAS.map(c => <MenuItem key={c} value={c}>{c}</MenuItem>)}
                  </Select>
                </FormControl>
              </Grid>
            </> : <>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Entidad</InputLabel>
                  <Select label="Entidad" value={s.entidad_id} onChange={this.set('entidad_id')}>
                    {s.entidades.map(e => <MenuItem key={e.id} value={e.id}>{e.nombre}</MenuItem>)}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Módulo</InputLabel>
                  <Select label="Módulo" value={s.modulo} onChange={this.set('modulo')}>
                    {MODULOS.map(m => <MenuItem key={m} value={m}>{m}</MenuItem>)}
                  </Select>
                </FormControl>
              </Grid>
            </>}

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Severidad</InputLabel>
                <Select label="Severidad" value={s.severidad} onChange={this.set('severidad')}>
                  {SEVERIDADES.map(sv => <MenuItem key={sv.nivel} value={sv.nivel}>Nivel {sv.nivel} — {sv.definicion}</MenuItem>)}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth type="datetime-local" label="Fecha aproximada de la falla" InputLabelProps={{ shrink: true }}
                value={s.fecha_problema} onChange={this.set('fecha_problema')} />
            </Grid>

            <Grid item xs={12}>
              <TextField fullWidth multiline minRows={3} label="Descripción del problema"
                value={s.descripcion} onChange={this.set('descripcion')} inputProps={{ maxLength: 5000 }} />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth multiline minRows={2} label="Información adicional (opcional)"
                value={s.info_adicional} onChange={this.set('info_adicional')} inputProps={{ maxLength: 5000 }} />
            </Grid>

            <Grid item xs={12}>
              <Button variant="outlined" component="label">
                {s.archivo ? s.archivo.name : 'Adjuntar evidencia (opcional)'}
                <input type="file" hidden accept="image/*,application/pdf"
                  onChange={(e) => this.setState({ archivo: e.target.files[0] || null })} />
              </Button>
              <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>Imagen o PDF, máx. 5 MB</Typography>
            </Grid>

            <Grid item xs={12}>
              <Button variant="contained" color="primary" disabled={s.enviando} onClick={this.enviar}>
                {s.enviando ? 'Enviando…' : 'Enviar solicitud'}
              </Button>
            </Grid>
          </Grid>}
        </Paper>

        <Snackbar open={s.snack.open} autoHideDuration={4000} onClose={() => this.setState({ snack: { ...s.snack, open: false } })}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
          <Alert severity={s.snack.severity} onClose={() => this.setState({ snack: { ...s.snack, open: false } })}>{s.snack.msg}</Alert>
        </Snackbar>
      </Box>
    )
  }
}

export default SoporteReportarPage
